<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card class="mb-base">
        <vs-table
          :max-items="10"
          pagination
          :data="jobList"
          multiple
          v-model="selectedjobs"
          search
        >
          <template slot="header">
            <!-- ADD NEW -->
            <div class="list-heading">
              {{ $t("admin.label.Scheduler Jobs") }}
            </div>
            <span class="vx-col order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-x"
                type="border"
                @click="updateScheduler('stop')"
                v-if="scheduler.active"
                size="small"
                >{{ $t("admin.label.Suspend") }}</vs-button
              >
              <vs-button
                icon-pack="feather"
                icon="icon-play"
                type="border"
                @click="updateScheduler('start')"
                v-else
                size="small"
                >{{ $t("admin.label.Activate") }}</vs-button
              >
            </span>
            <span class="vx-col order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-play"
                @click="executeJob"
                size="small"
                style="height: 34px;"
                >{{ $t("admin.label.Execute") }}</vs-button
              >
            </span>
            <span class="vx-col order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-refresh-ccw"
                @click="getSchedulerJob"
                size="small"
                class="truncate p-2"
              ></vs-button>
            </span>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("admin.label.Name") }}</vs-th>
            <vs-th>{{ $t("admin.label.Status") }}</vs-th>
            <vs-th>{{ $t("admin.label.Next Run") }}</vs-th>
            <vs-th>{{ $t("admin.label.Previous Run") }}</vs-th>
            <vs-th>{{ $t("admin.label.Previous Run Status") }}</vs-th>
            <vs-th sort
              ><span @click="sortActive">
                {{ $t("admin.label.Active") }}
                <feather-icon
                  icon="CodeIcon"
                  title="Sort"
                  class="rotate-90"
                  svgClasses="w-4 h-4 stroke-current"
                />
              </span>
            </vs-th>

            <vs-th class="tHeadCenter">{{ $t("admin.label.Action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              @click.stop="test"
              :key="index"
              :data="job"
              v-for="(job, index) in data"
            >
              <vs-td :data="job.displayName"
                ><div @click.stop="handleSelected(job)">
                  {{ job.displayName }}
                </div></vs-td
              >
              <vs-td :data="job.active"
                ><div @click.stop="handleSelected(job)">
                  {{ job.active }}
                </div></vs-td
              >
              <vs-td :data="job.nextRunTime"
                ><div @click.stop="handleSelected(job)">
                  {{ getDate(job.nextRunTime) }}
                </div></vs-td
              >
              <vs-td
                ><div @click.stop="handleSelected(job)">
                  {{ getpreviousdate(job.lastRunHistory) }}
                </div></vs-td
              >
              <vs-td :data="job.lastRunHistory"
                ><div @click.stop="handleSelected(job)">
                  {{ getpreviousstatus(job.lastRunHistory) }}
                </div></vs-td
              >
              <vs-td
                ><vs-switch
                  @change.stop="test(job)"
                  color="success"
                  success
                  v-model="job.active"
              /></vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    title="Edit"
                    icon="EditIcon"
                    @click.stop="editJobs(job)"
                    svgClasses="w-5 h-5 stroke-current orange_icon"
                    class="icon_row"
                  />
                  <feather-icon
                    title="Edit Job Parameter"
                    icon="BookIcon"
                    @click.stop="getJob(job.jobId)"
                    svgClasses="w-5 h-5 stroke-current"
                    class="icon_row"
                  />
                  <feather-icon
                    title="View History"
                    icon="BarChart2Icon"
                    @click.stop="openHistory(job.jobId)"
                    svgClasses="w-5 h-5 stroke-current"
                    class="icon_row"
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('admin.label.Edit Jobs Parameters')"
          :active.sync="jobsParameterPopup"
          class="popup-close mid-popup"
        >
          <ValidationObserver ref="observer1">
            <form>
              <div
                v-if="jobparam && jobparam.NGBPramList && jobparam.NGBPramList.length > 0"
              >
                <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                  <div
                    class="vx-col sm:w-full w-full mb-1"
                    v-for="(item, index) in jobparam.NGBPramList"
                  >
                    <div class="dropdown-with-label" v-if="item.paramType === 'COMBO'">
                      <small class="date-label">{{ item.paramName }} </small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="item.paramName"
                        :key="resetKey"
                      >
                        <v-select
                          label="batchName"
                          v-model="item.paramValue"
                          :placeholder="$t('placeholder.label.SelectOne')"
                          :options="jobParameters.queryData"
                          :reduce="(obj) => obj.batchName"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          class="min-w-100"
                          style="width: 100%"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                    <div class="dropdown-with-label" v-if="item.paramType === 'DATE'">
                      <small class="date-label">{{ item.paramName }}</small>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="item.paramName"
                        :key="resetKey"
                      >
                        <flat-pickr
                          :config="configdateTimePicker"
                          class="w-full"
                          v-model="item.paramValue"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                    <div
                      v-if="item.paramType === 'TEXT'"
                      class="vx-col sm:w-full w-full"
                    >
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :name="item.paramName"
                        :key="resetKey"
                      >
                        <vs-input
                          :label="item.paramName"
                          type="text"
                          v-model="item.paramValue"
                          class="w-full mb-2 font-semibold"
                        />
                        <span class="validate-error" style="color: red">{{
                          errors[0]
                        }}</span>
                      </ValidationProvider>
                    </div>
                    <div
                      class="vx-col sm:w-full w-full my-5"
                      v-if="item.paramType === 'DATE'"
                    >
                      <vs-checkbox
                        class="mt-3 font-semibold"
                        :value="item.isDynamicRaw === 'Y'"
                        @change="item.isDynamicRaw = $event ? 'Y' : 'N'"
                        >{{ $t("admin.label.Is Dynamic") }}</vs-checkbox
                      >
                    </div>
                  </div>
                </div>
                <div class="vx-col w-full flex justify-center mt-3">
                  <span class="ml-4 mr-1">
                    <vs-button type="border" @click="jobsParameterPopup = false">{{
                      $t("admin.label.Cancel")
                    }}</vs-button>
                  </span>
                  <span class="ml-1 mr-2">
                    <vs-button @click="updateJobParam">{{
                      $t("admin.label.Submit")
                    }}</vs-button>
                  </span>
                </div>
              </div>
              <div class="text-center" v-else>No Data Available.</div>
            </form>
          </ValidationObserver>
        </vs-popup>
      </div>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('admin.label.Edit Scheduler Job')"
          :active.sync="editJobsPopup"
          class="popup-close mid-popup"
        >
          <ValidationObserver ref="observer">
            <form>
              <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                <div class="vx-col sm:w-full w-full">
                  <div class="vx-col sm:w-full w-full mb-2">
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      :name="$t('admin.label.Job Name')"
                      :key="resetKey"
                    >
                      <vs-input
                        :label="$t('admin.label.Job Name')"
                        type="text"
                        v-model="jobs.displayName"
                        class="w-full mb-2 font-semibold"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col sm:w-full w-full mt-2 mb-2">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('admin.label.Cron Expression')"
                    :key="resetKey"
                  >
                    <vs-input
                      :label="$t('admin.label.Cron Expression')"
                      type="text"
                      v-model="jobs.cronExpression"
                      class="w-full mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col sm:w-full w-full mt-2 mb-2">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('admin.label.Cron Description')"
                    :key="resetKey"
                  >
                    <vs-input
                      :label="$t('admin.label.Cron Description')"
                      type="text"
                      v-model="jobs.cronDescription"
                      class="w-full mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="center">
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="updateJob"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("admin.label.Save") }}</vs-button
                  >
                </span>
              </div>
            </form>
          </ValidationObserver>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
const bulkUploadsObj = {
  name: "",
  description: "",
  file: null,
};
export default {
  data() {
    return {
      loading: false,
      editJobsPopup: false,
      jobsParameterPopup: false,
      bulkUploadsPopup: false,
      resetKey: 0,
      selectedjobs: [],
      bulkUploads: bulkUploadsObj,
      jobList: [],
      count: 0,
      jobs: {
        displayName: "",
        cronExpression: "",
        cronDescription: "",
      },
      jobparam: {
        batchName: "",
      },
      id: "",
      active: false,
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "Y-m-d H:i:s",
        enableSeconds: true,
        time_24hr: true,
      },
    };
  },
  components: {
    "v-select": vSelect,
    flatPickr,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    SchedulerJobs() {
      return this.$store.getters["admin/getJobs"];
    },
    ...mapState({
      jobParameters: (state) => state.admin.jobParameters,
      scheduler: (state) => state.admin.scheduler,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    openHistory(id) {
      this.$router.push(`/scheduler_history/${id}`);
    },
    getDate(date) {
      const timeFormat = "hh:mm A";
      const combinedFormat = `${this.formattedDate} ${timeFormat}`;
      return moment(date).format(combinedFormat);
    },
    async test(job) {
      let payload = {
        cronExpression: job.cronExpression,
        displayName: job.displayName,
        active: job.active,
      };
      try {
        await this.$store.dispatch("admin/updateJobAction", {
          id: job.jobId,
          data: payload,
        });
        this.getSchedulerJob();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    sortActive() {
      if (this.count % 2 == 0)
        this.jobList = this.jobList.sort((a, b) => (a.active < b.active ? 1 : -1));
      else this.jobList = this.jobList.sort((a, b) => (a.active < b.active ? -1 : 1));
      this.count++;
    },
    async updateScheduler(status) {
      await this.$store.dispatch("admin/updateScheduler", status);
      this.getSchedulerJob();
    },
    editJobs(job) {
      this.editJobsPopup = true;
      this.resetKey++;
      this.jobs.displayName = job.displayName;
      this.jobs.cronDescription = job.cronDescription;
      this.jobs.cronExpression = job.cronExpression;
      this.jobs.active = job.active;
      this.id = job.jobId;
    },
    async updateJob() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      try {
        await this.$store.dispatch("admin/updateJobAction", {
          id: this.id,
          data: this.jobs,
        });
        this.editJobsPopup = false;
        this.getJobs();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Jobs Updated successfully!",
          type: "success",
        });
      } catch (error) {
        const errorMessage = String(error.httpStatusCode).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async executeJob() {
      for (let temp of this.selectedjobs) {
        await this.$store.dispatch("admin/executeJobsAction", temp.jobId);
      }
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Jobs Executed successfully!",
        type: "success",
      });
    },
    async updateJobParam() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;
      const payload = {
        jobParameters: this.jobparam.NGBPramList,
      };

      for (let item of payload.jobParameters) {
        if (item.paramType === "DATE") {
          item.paramValue = moment(item.paramValue).format("YYYY-MM-DD HH:mm:ss");
        }
      }
      try {
        await this.$store.dispatch("admin/updateJobParameterAction", {
          id: this.id,
          data: payload,
        });
        this.jobsParameterPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "JobParams updated successfully!",
          type: "success",
        });
      } catch (e) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something went wrong",
          type: "warning",
        });
      }
    },
    getpreviousdate(obj) {
      if (obj) return this.getDate(obj.jobRunEndTime);
      else return "";
    },
    getpreviousstatus(obj) {
      if (obj) return obj.status;
      else return "";
    },
    handleSelected(item) {
      this.$router.push({ path: `/view_scheduler_job/${item.jobId}` });
    },
    async getSchedulerJob() {
      this.loading = true;
      await this.$store.dispatch("admin/getSchedulerState");
      this.getJobs();
      this.loading = false;
    },
    async getJobs() {
      try {
        await this.$store.dispatch("admin/setJobs");
        this.jobList = [...this.SchedulerJobs];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getJob(id) {
      this.jobsParameterPopup = true;
      this.resetKey++;
      this.jobparam = {};
      this.id = id;
      try {
        await this.$store.dispatch("admin/getJobParameters", id);
        this.jobparam = { ...this.jobParameters };
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.getSchedulerJob();
  },
};
</script>
